module.exports = __webpack_public_path__ + "static/request-splash-4b6da71ad37ec18450b36f4456b21b40.jpg";